import './main.css';
import './App.css';
import Navbar from './Navbar.js';
import Hero from './Hero';
import About from './About';
import Benefits from './Benefits';
import Services from './Services';
import Banner from './Banner';
import Footer from './Footer';
const offers = [
  {
    "title": "First time in our sQuad, get 30% OFF",
    "details": "Get 30% off on your first fee payment, with 10 days Demo Class for FREE",
    "image": "/images/family.jpg",
    "code": "FIRST30",
  },
  {
    "title": "Refer a Friend, get 10% OFF",
    "details": "Get 10% off on your fee payment, with 10 days Demo Class for FREE (For first time users only)",
    "image": "/images/bench-mate.jpg",
    "code": "REFER10",
  }
]
function App() {
  const currOffer = offers[Math.floor(Math.random() * offers.length)];
  return (
    <>
      <Navbar></Navbar>
      <Hero></Hero>
      <About></About>
      <Benefits></Benefits>
      <Banner banner={currOffer}></Banner>
      <Services></Services>
      <Footer></Footer>
    </>
  );
}

export default App;
